import React from 'react';
import ModalPDQConfirmationComponent from './modal-pdq-confirmation.component';

function ModalPDQConfirmation(props) {
    return <ModalPDQConfirmationComponent {...props} />;
}

export default ModalPDQConfirmation;
